import { Injectable } from '@angular/core';

import { map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as ConversationsActions from './actions';
import { WaitingRoomService } from '../waiting-room.service';
import { Conversation } from '../../models/Conversation';
import { getTourMode } from '../../state/selectors';
import { Store } from '@ngrx/store';
import { AppState } from '../../state/reducers';
import { Noop } from '../../state/actions';
import { getCurrentPractice } from '../../practices/state/selectors';
import { Theme } from '../../enums/theme';

@Injectable()
export class ConversationsEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private waitingRoomService: WaitingRoomService
  ) {
  }

  getConversations$ = createEffect(() => this.actions$.pipe(
    ofType(ConversationsActions.GetConversations),
    withLatestFrom(this.store.select(getTourMode), this.store.select(getCurrentPractice)),
    mergeMap(([action, tourMode, currentPractice]) => this.waitingRoomService.getConversations(action.practiceId)
      .pipe(
        map((conversations: Conversation[]) => {
          if (tourMode) {
            return Noop();
          }

          const theme = currentPractice?.theme;
          
          conversations = conversations.map(conversation => {
            if (theme === Theme.Provet && conversation.status) {
              if (conversation.status.name === 'With Client') {
                conversation.status.color = '#3451b2';
              }
        
              if (conversation.status.name === 'With clinic') {
                conversation.status.color = '#793aaf';
              }
            }
            return conversation;
          });

          return ConversationsActions.GetConversationsSuccess({conversations: conversations});
        })
      ))
    )
  );

  getResolvedConversations$ = createEffect(() => this.actions$.pipe(
    ofType(ConversationsActions.GetResolvedConversations),
    mergeMap((action) => this.waitingRoomService.getResolvedConversations(action.practiceId)
      .pipe(
        map((result: Conversation[]) => {
          return ConversationsActions.GetResolvedConversationsSuccess({conversations: result});
        })
      ))
    )
  );
}
